import PageSEO from "@/components/feature/PageSEO";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import FeaturedCategories from "./components/FeaturedCategories";
import CategoryGrid from "./components/CategoryGrid";
import CTASection from "./components/CTASection";
import Testimonial from "./components/Testimonial";
import SEOContent from "./components/SEOContent";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://oopbuyspreadsheets.mom";

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "OOPBUY Spreadsheet",
  "url": siteUrl,
  "description": "Smart sourcing and inventory management tool for e-commerce entrepreneurs. Compare suppliers, track orders, and calculate profit margins with purpose-built spreadsheet templates.",
  "potentialAction": {
    "@type": "SearchAction",
    "target": `${siteUrl}/?q={search_term_string}`,
    "query-input": "required name=search_term_string",
  },
};

const softwareSchema = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  "name": "OOPBUY Spreadsheet",
  "applicationCategory": "BusinessApplication",
  "operatingSystem": "Web",
  "description": "Purpose-built sourcing and inventory management spreadsheet tool for e-commerce entrepreneurs. Features supplier comparison matrix, bulk order calculator, profit margin tracker, and 14 category-specific templates.",
  "url": siteUrl,
  "offers": {
    "@type": "Offer",
    "price": "0",
    "priceCurrency": "USD",
    "description": "Free to try",
  },
};

const ogImage = "https://readdy.ai/api/search-image?query=Modern%20clean%20spreadsheet%20dashboard%20interface%20with%20warm%20terracotta%20and%20cream%20color%20scheme%2C%20organized%20data%20visualization%2C%20professional%20SaaS%20tool%20hero%20image%2C%20minimalist%20design%2C%20soft%20gradient%20background%2C%20productivity%20theme&width=1200&height=630&seq=og-image-v3-2026&orientation=landscape";

export default function Home() {
  return (
    <main>
      <PageSEO
        title="OOPBUY Spreadsheet — Smarter E-commerce Sourcing Tool"
        description="OOPBUY Spreadsheet is a purpose-built sourcing and inventory management tool for e-commerce entrepreneurs. Compare suppliers, track orders, calculate profit margins, and manage 500+ SKUs effortlessly with smart spreadsheet automation."
        keywords="oopbuy spreadsheet, spreadsheet automation, sourcing tool, inventory management, ecommerce spreadsheet, supplier comparison, excel alternative, dropshipping tool"
        canonicalPath="/"
        ogType="website"
        ogImage={ogImage}
        schemas={[websiteSchema, softwareSchema]}
      />
      <Navbar />
      <Hero />
      <FeaturedCategories />
      <CategoryGrid />
      <CTASection />
      <Testimonial />
      <SEOContent />
      <Footer />
    </main>
  );
}